import React from 'react'
import { Grid, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'

interface FiltersFooterProps {
  readonly loading?: any
  readonly handleClearFilters: () => void
  readonly searchInfo: () => void
  readonly translate: (key: string) => string
  readonly labelButton?: any
}

export default function FiltersFooter({
  loading,
  handleClearFilters,
  searchInfo,
  translate,
  labelButton,
}: FiltersFooterProps) {
  return (
    <Grid
      container
      direction={'row'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        padding: 2,
        gap: 2,
      }}
    >
      <Button variant="outlined" onClick={handleClearFilters}>
        {translate('Clear Filters')}
      </Button>
      <LoadingButton
        loading={loading?.get()}
        variant="contained"
        onClick={searchInfo}
      >
        {translate(labelButton?.get() ? labelButton.get() : 'Search')}
      </LoadingButton>
    </Grid>
  )
}